/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_CopyInputs */



/**
* | output |
* | --- |
* | "Copy event or selected text" |
*
* @param {Shortcut_Keys_Desc_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_copy = /** @type {((inputs?: Shortcut_Keys_Desc_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier l'evenement ou le texte selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis oder ausgewählten Text kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia l'evento o il testo selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать событие или выделенный текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar evento o texto seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制事件或选定文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントまたは選択したテキストをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट या चयनित टेक्स्ट को कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar evento ou texto selecionado")
	return /** @type {LocalizedString} */ ("Copy event or selected text")
});